//componente per l'aggiunta layer da url
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
// import {addLayerUrl} from '../redux'
// import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {addLayerUrl} from '../redux';
import Tooltip from '@material-ui/core/Tooltip';


const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(0),
      width: '30.5ch',
      maxWidth: '-webkit-fill-available',
      marginRight: '10px',
      marginLeft: '10px'
    },
      '& input:valid + fieldset': {
        borderColor: 'black',
        borderWidth: 1,
      },
  },
}));

 function InserisciURL(props) {
  const classes = useStyles();
  const [url, setUrl] = React.useState('');
  const [nomeLayer,setNomeLayer] = React.useState('')
  const handleChangeUrl = (event) => {
     setUrl(event.target.value)
  };

  const handleUpdate = () =>{
    props.callback(url);
    

      //  props.addLayerUrl({url: url,nome: nomeLayer,type: props.typeLayer.typeLayer})

  }

//const handleChangeName = (event) => {
  //setNomeLayer(event.target.value)
//}
function reset(){
  
  props.callback(null)
  props.addLayerUrl({url:null,name:null,check:null})
  


}
const { t } = useTranslation();

  return (<div>
    <form className={classes.root} noValidate autoComplete="off">
      <TextField
        id="Inserisci URL"
        label={t("Inserisci URL")}
        variant="outlined"
        color="primary"
        size="small"
        onChange={handleChangeUrl}
      />
    </form>
    <div className={"aggiungiButtonuttonDiv"}>
    <button className={"aggiungiButtonStyle"} onClick={handleUpdate} ><Trans>Aggiungi</Trans></button>
    <Tooltip title="Reset"><button className={"resetBottonStyle"} onClick={reset}>Reset</button></Tooltip>
    </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
      layerUrl: state.layerUrl
  }
}
const mapDispatchToProps = dispatch => {
  return {
    addLayerUrl: (layerUrl) => dispatch(addLayerUrl(layerUrl))
  }
}
// const mapStateToProps = state => {
//   return {
//       layerUrl: state.layerUrl,
//       typeLayer: state.typeLayer
//   }
// }
// const mapDispatchToProps = dispatch => {
//   return {
//     addLayerUrl: (layerUrl) => dispatch(addLayerUrl(layerUrl))
//   }
// }
// export default connect(mapStateToProps,mapDispatchToProps) (InserisciURL);
export default connect(mapStateToProps,mapDispatchToProps) (InserisciURL)